import Icon from '../components/Icon.vue'

Icon.register({
  sleigh: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M612.7 350.7L603.4 343.3C596.5 337.8 586.4 338.9 580.9 345.8L570.9 358.3C565.4 365.2 566.5 375.3 573.4 380.8L582.7 388.2C588.6 392.9 591.9 399.9 591.9 407.4 591.9 421 580.9 432 567.3 432H48C39.2 432 32 439.2 32 448V464C32 472.8 39.2 480 48 480H564C603 480 637.7 450.7 639.9 411.7 641.3 387.9 631.2 365.4 612.7 350.7zM32 224C32 283.6 72.9 333.2 128 347.5V400H192V352H384V400H448V352C501 352 544 309 544 256V160C561.7 160 576 145.7 576 128S561.7 96 544 96H448V160C448 195.3 419.3 224 384 224H363.3C297.5 224 237.4 186.8 208 128 178.6 69.2 118.4 32 52.7 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96V224z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sleigh.js
// module id = L/ee
// module chunks = 144